import { Accordion as ChakraAccordion, Box, Heading, Text } from '@chakra-ui/react';

import { AccordionProps } from './accordion.props';

export const Accordion = ({ title, heading, items, wrapperProps }: AccordionProps): JSX.Element => {
    return (
        <Box {...wrapperProps}>
            <Text fontSize="md">{title}</Text>
            <Heading size="lg" mb={6}>
                {heading}
            </Heading>
            <ChakraAccordion.Root
                as="dl"
                collapsible={true}
                variant={'enclosed'}
                borderRadius={'lg'}
            >
                {items?.map(({ id, title, body }, i) => (
                    <ChakraAccordion.Item key={id} value={id}>
                        <dt>
                            <ChakraAccordion.ItemTrigger>
                                <Text as="span" mr="auto" textAlign="left">
                                    {title}
                                </Text>
                                <ChakraAccordion.ItemIndicator color={'secondary.solid'} />
                            </ChakraAccordion.ItemTrigger>
                        </dt>
                        <ChakraAccordion.ItemContent as="dd" pb={4}>
                            <ChakraAccordion.ItemBody>{body}</ChakraAccordion.ItemBody>
                        </ChakraAccordion.ItemContent>
                    </ChakraAccordion.Item>
                ))}
            </ChakraAccordion.Root>
        </Box>
    );
};
